import React from 'react';
import { Redirect, Route, Switch } from 'react-router';

import { routes } from 'client/lib/routes';
import { Channel } from 'client/model/skill';
import { getAccessAsViewer, showAppStoreUi, showAutoAppUi, showSmartScreenUi } from 'client/utils';

import AllAvailableAppsByChannel from './AllAvailableAppsByChannel';

export const AllAvailableAppsRouter = () => {
    if (!getAccessAsViewer() || !showAppStoreUi()) {
        return (
            <Switch>
                <Redirect to={routes.app.root} />
            </Switch>
        );
    }

    return (
        <Switch>
            <Route path={routes.app.allAppsByChannel(Channel.TvApp)} exact>
                <AllAvailableAppsByChannel channel={Channel.TvApp} />
            </Route>
            <Route path={routes.app.allAppsByChannel(Channel.AutoApp)} exact>
                {showAutoAppUi() ? (
                    <AllAvailableAppsByChannel channel={Channel.AutoApp} />
                ) : (
                    <Redirect to={routes.app.root} />
                )}
            </Route>
            <Route path={routes.app.allAppsByChannel(Channel.SmartScreenApp)} exact>
                {showSmartScreenUi() ? (
                    <AllAvailableAppsByChannel channel={Channel.SmartScreenApp} />
                ) : (
                    <Redirect to={routes.app.root} />
                )}
            </Route>
            <Route>
                <AllAvailableAppsByChannel channel={Channel.TvApp} />
            </Route>
        </Switch>
    );
};
